import { render, staticRenderFns } from "./PointsModal.vue?vue&type=template&id=85305e7e"
import script from "./PointsModal.vue?vue&type=script&lang=js"
export * from "./PointsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports